var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('draggable',{on:{"start":_vm.start,"end":_vm.end}},_vm._l((_vm.list),function(d){return _c('p',{key:d.id},[_vm._v(_vm._s(d.name))])}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }